import React from 'react';
import {SelfAdminUserDisplayType} from '../layout/SelfAdminLayout';

type SelfAdminContextType = {
  typeView: SelfAdminUserDisplayType,
  setTypeView: (type: SelfAdminUserDisplayType) => void
};

export const SelfAdminContext = React.createContext<SelfAdminContextType>({typeView: 'SYNTHESIS'} as SelfAdminContextType);
